export default {
  "content": "<path d=\"M46.8 0H5.2A5.2 5.2 0 000 5.2v31.2c0 2.9 2.3 5.2 5.2 5.2h41.6c2.9 0 5.2-2.3 5.2-5.2V5.2C52 2.3 49.7 0 46.8 0zm0 36.4H5.2V20.8h41.6v15.6zm0-26H5.2V5.2h41.6v5.2z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "52",
    "height": "42",
    "viewBox": "0 0 52 42"
  }
};